import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CButton, CForm, CFormInput, CFormLabel, CFormText, CFormTextarea } from "@coreui/react-pro";

import VisibilitySensor from "react-visibility-sensor";

import email from "../../../assets/img/contact/contactOne/email.webp";
import phone from "../../../assets/img/contact/contactOne/phone.webp";
import whats from "../../../assets/img/contact/contactOne/whatsapp.webp";
import { sendContactEmail } from "../../../services/sendContactEmail";
import { useAlert } from "../../../contexts/AlertContext";
import { trackLead } from "../../../utils/tracking";

function ContactOne() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  const defaultFormData = {
    name: '',
    enterprise: '',
    email: '',
    phone: '',
    message: '',
    setor: '',


    isLoadingResponse: false
  }

  const [formData, setFormData] = useState(defaultFormData)
  const [errors, setErrors] = useState({})

  const formatPhoneValue = (event) => {
    const formattedPhone = event.target.value
      .replace(/\D/g, '') // Remove todos os caracteres não numéricos
      .replace(/^(\d{2})(\d)/g, '($1) $2') // Adiciona parênteses em volta dos dois primeiros dígitos
      .replace(/(\d)(\d{4})$/, '$1-$2'); // Adiciona hífen entre o quinto e o sexto dígitos

    setFormData(prev => ({ ...prev, phone: formattedPhone }))
  }

  const {showAlert} = useAlert()


  const validateForm = () => {
    const newErrors = {}
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!formData.name || formData.name.trim().length < 3)
      newErrors.name = t("form_error_name")
    if (!formData.email || !emailRegex.test(formData.email.trim()))
      newErrors.email = t("form_error_email")
    if (!formData.phone || formData.phone.replace(/\D/g, "").length < 10)
      newErrors.phone = t("form_error_phone")

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    if (!validateForm()) return

    setFormData(prev => ({ ...prev, isLoadingResponse: true }))


    const response = await sendContactEmail(formData)

    if (response.success) {
      setFormData(defaultFormData)
      setErrors({})

      trackLead('contato_institucional', { setor: formData.setor })

      if (window.lintrk) {
        window.lintrk('track', { conversion_id: 27407465 })
      }
    }

    showAlert(response.message, response.success ? 'success' : 'error')
    setFormData(prev => ({ ...prev, isLoadingResponse: false }))
  }


  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div className={`contactOne ${isVisible ? 'visible' : ''}`}>
        <div className="contactOneText">
          <h1 className={`${isVisible ? 'visible' : ''}`}>{t("contact_title")} <span>{t("contact_title_span")}</span></h1>
          <p className={`${isVisible ? 'visible' : ''}`}>{t("contact_text")}</p>
          <p className={`address ${isVisible ? 'visible' : ''}`}>GH OPERADOR LOGISTICO LTDA - 07.656.322/0001-32</p>
          <div className="contacts">
            <div className={`email ${isVisible ? 'visible' : ''}`}>
              <img src={email} alt="" width={'20px'} height={'15px'} />
              <p>contato@ghlogistica.com.br</p>
            </div>
            <div className={`phone ${isVisible ? 'visible' : ''}`}>
              <img src={phone} alt="" width={'20px'} />
              <p>(47) 3045-1700 </p>
            </div>
{/*             <div className={`phone phone2 ${isVisible ? 'visible' : ''}`}>
              <img src={whats} alt="" width={'20px'}/>
              <p>(47) 99220-4104</p>
            </div> */}
          </div>
        </div>
        <CForm id="institucionalForm" className={`${isVisible ? 'visible' : ''}`}>
          <div>
            <CFormLabel className="me-2 labelName">{t("contact_name")}</CFormLabel>
            <CFormInput
              type="text"
              maxLength={80}
              minLength={3}
              value={formData.name}
              onChange={(e) => {
                setFormData(prev => ({ ...prev, name: e.target.value }))
                setErrors(prev => ({ ...prev, name: undefined }))
              }}
              className="me-2 inputName"
              placeholder=""
              invalid={!!errors.name}
            ></CFormInput>
            {errors.name && <CFormText className="text-danger">{errors.name}</CFormText>}
            <CFormLabel>{t("contact_company")}</CFormLabel>
            <CFormInput
              type="text"
              autoComplete='off'
              maxLength={40}
              className="me-2"
              placeholder=""
              value={formData.enterprise}
              onChange={(e) => setFormData(prev => ({ ...prev, enterprise: e.target.value }))}
            ></CFormInput>
            <CFormLabel>{t("contact_email")}</CFormLabel>
            <CFormInput
              type="email"
              autoComplete='off'
              maxLength={60}
              className="me-2"
              placeholder=""
              value={formData.email}
              onChange={(e) => {
                setFormData(prev => ({ ...prev, email: e.target.value }))
                setErrors(prev => ({ ...prev, email: undefined }))
              }}
              invalid={!!errors.email}
            ></CFormInput>
            {errors.email && <CFormText className="text-danger">{errors.email}</CFormText>}
            <CFormLabel className="mt-4">{t("contact_phone")}</CFormLabel>
            <CFormInput
              type="phone"
              autoComplete='off'
              maxLength={15}
              minLength={15}
              onChange={(e) => {
                formatPhoneValue(e)
                setErrors(prev => ({ ...prev, phone: undefined }))
              }}
              className="me-2"
              placeholder=""
              value={formData.phone}
              invalid={!!errors.phone}
            ></CFormInput>
            {errors.phone && <CFormText className="text-danger">{errors.phone}</CFormText>}
            <CFormLabel className="mt-4">{t("contact_sector")}</CFormLabel>
            <CFormInput
              type="text"
              className="me-2"
              placeholder=""
              value={formData.setor}
              onChange={(e) => setFormData(prev => ({ ...prev, setor: e.target.value }))}
            />
            <CFormLabel className="mt-4">{t("contact_message")}</CFormLabel>
            <CFormTextarea
              type="text"
              autoComplete='off'
              maxLength={300}
              minLength={25}
              rows={4}
              as="text-area"
              className="me-2 message"
              placeholder=""
              value={formData.message}
              onChange={(e) => setFormData(prev => ({ ...prev, message: e.target.value }))}
            ></CFormTextarea>
            <CButton className="mt-4" onClick={handleSubmit} disabled={formData.isLoadingResponse}>
              {formData.isLoadingResponse ? t("contact_sending") : t("contact_send")}
            </CButton>
          </div>
        </CForm>
      </div>
    </VisibilitySensor>
  )
}
export default ContactOne;